"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TableBody = void 0;

var _react = _interopRequireWildcard(require("react"));

var _lodash = _interopRequireDefault(require("lodash"));

var _classnames = _interopRequireDefault(require("classnames"));

var _TableContext = _interopRequireDefault(require("./TableContext"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}
/**
 * Iterates through the rows to add even/odd classes, and set flag for expand control/spacer
 * @param rows
 */


var modifyChildren = function modifyChildren(rows) {
  // get rows as array
  var childrenAsArray = _react.default.Children.toArray(rows); // iterate through children and update props


  return _react.default.Children.map(childrenAsArray, function (row, index) {
    var classNames = _lodash.default.get(row, ['props', 'classNames', '']);

    var classToAdd = index % 2 === 0 ? 'even' : 'odd';
    return _react.default.cloneElement(row, {
      // add the even/odd class name
      classNames: (0, _classnames.default)(classNames, classToAdd)
    });
  });
};

var TableBody = function TableBody(props) {
  var children = props.children;

  var _useContext = (0, _react.useContext)(_TableContext.default),
      hasExtraRows = _useContext.hasExtraRows,
      setHasExtraRows = _useContext.setHasExtraRows; // check if any of our children have extra rows


  var hasChildrenWithExtraRows = _lodash.default.reduce(_react.default.Children.toArray(children), function (result, row) {
    if (_lodash.default.get(row, ['props', 'extraRows'], false)) {
      return true;
    }

    return false;
  }, false); // update context if value has changed


  if (hasChildrenWithExtraRows !== hasExtraRows) {
    setHasExtraRows(!!hasChildrenWithExtraRows);
  }

  return /*#__PURE__*/_react.default.createElement("tbody", {
    className: "table-body"
  }, modifyChildren(children));
};

exports.TableBody = TableBody;
var defaultProps = {
  classNames: {}
};
TableBody.defaultProps = defaultProps;
var _default = TableBody;
exports.default = _default;